import dayjs from 'dayjs'
import { FAMILIARIZATION_DAY, presenceTypes } from 'abcreche-constants/src/const/attendances/types'
import AttendanceRepository from './AttendanceRepository.js'
import ParentRepository from './ParentRepository.js'
import ActivityRepository from './ActivityRepository.js'

// Copy of today's urgency list kept on the device, shown when the tablet has no internet
const STORAGE_KEY = 'abc_urgency_list'

// Children currently present (arrived, not left yet, not in "Interruption de service") with their parents, sorted by classroom.
// `calendar` items must have a `presence` property.
export function buildUrgencyList (calendar, activities, parents) {
    return calendar
        .filter(babyCalendar => babyCalendar.presence && !babyCalendar.presence.left_at && !activities.find(a =>
            a.activityCategory?.name === 'Interruption de service'
            && a.registration?.uuid === babyCalendar.baby.registration?.uuid
        ))
        .map((babyCalendar) => {
            babyCalendar.parents = parents.filter(parent => parent.babies.find(baby => baby.uuid === babyCalendar.baby.uuid))
            return babyCalendar
        })
        .sort((a, b) => (a.classroom?.name > b.classroom?.name) ? 1 : -1)
}

const UrgencyListRepository = {
    // Fetches today's full list (all classrooms) and stores it on the device
    async refresh () {
        const date = dayjs().format('YYYY-MM-DD')

        const calendar = (await AttendanceRepository.calendar({ with_classroom: true, from: date, to: date })).data
            .filter(babyCalendar => babyCalendar.attendances[date])
            .map(babyCalendar => ({
                ...babyCalendar,
                presence: babyCalendar.attendances[date].findLast(a => [...presenceTypes, FAMILIARIZATION_DAY].includes(a.type))
            }))

        const [activities, parents] = await Promise.all([
            ActivityRepository.getAll({ from: date, to: date }),
            calendar.length ? ParentRepository.fetchAll({ baby_uuids: calendar.map(b => b.baby.uuid) }) : { data: [] }
        ])

        const list = buildUrgencyList(calendar, activities.data, parents.data).map(babyCalendar => ({
            baby: { full_name: babyCalendar.baby.full_name, date_of_birth: babyCalendar.baby.date_of_birth },
            classroom: babyCalendar.classroom ? { name: babyCalendar.classroom.name } : null,
            parents: babyCalendar.parents.map(p => ({
                first_name: p.first_name,
                last_name: p.last_name,
                mobile: p.mobile,
                phone: p.phone,
                professional_phone: p.professional_phone
            }))
        }))

        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            saved_at_label: dayjs().format('DD/MM/YYYY à HH:mm'),
            list
        }))
    },

    get () {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY))
        } catch {
            return null
        }
    },

    clear () {
        localStorage.removeItem(STORAGE_KEY)
    }
}

export default UrgencyListRepository
